<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class=" mb-5  background_color" >
              <h6 class="manage-boder pt-2 font1  decoration"><router-link class="decoration" to="/"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Vehicles  </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Vehicle Inventory  </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/idealerassignvehicle/index"> Manage Allocate Vehicles</router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Create Allocate Vehicles  </h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
<div style="padding-bottom: 200px;" class="container-fluid">
  <div class="card bdr-rad2 mt-1 shadow p-2">
  <div  class="card-body custom_bdr_rds">


    <b-modal :id="infoModal2.id" 
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      size="lg" hide-footer
     bottom>
    <template   #modal-title>
     
      <h5 >View Pending Quotations</h5>

      
  
    </template>
    
   <div>
    <table class="table table-sm table-info table-striped font-size_def">
          <thead>
              <tr>
                  <th style="width:10%">Quotation</th>
                  <th style="width:20%;">Dealer name</th>
                  <th style="width:20%;">Sales Person</th>
                  <th style="width:20%;">Qty</th>
                
               
                  
              </tr>                        
          </thead>
          <tbody id="">
            <tr v-for="conten in infoModal2.content" :key="conten.C_name">
              <td>{{ conten.qu_code  }}</td>
              <td>{{ conten.C_name }}</td>
              <td>{{ conten.name }}</td>
              <td>{{ conten.Qty }}</td>
            </tr>
            <tr>
              <th></th>
              <th>Total Available Qty</th>
              <th></th>
              <th>{{ qty }}</th>
            </tr>
               
          </tbody>
          </table>

   </div>

  

  
  </b-modal>


  <b-modal :id="infoModal1.id" 
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      size="lg" hide-footer
     bottom>
    <template   #modal-title>
     
      <h5 >View Pending Quotations</h5>

      
  
    </template>
    
   <div>
    <table class="table table-sm table-info table-striped font-size_def">
          <thead>
              <tr>
                  <th style="width:10%">Quotation</th>
                  <th style="width:20%;">Dealer name</th>
                  <th style="width:20%;">Value</th>
                  <th style="width:20%;">Sales Person</th>
                
               
                  
              </tr>                        
          </thead>
          <tbody id="">
            <tr v-for="conten in infoModal1.content" :key="conten.C_name">
              <td>{{ conten.qu_code  }}</td>
              <td>{{ conten.C_name }}</td>
              <td>{{ conten.total }}</td>
              <td>{{ conten.name }}</td>
            </tr>
               
          </tbody>
          </table>

   </div>

  

  
  </b-modal>

   

                    <form @submit.prevent="SaveQuotation()" >


<div class="row">


    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Sales Person</label>
            <v-select  class="font-size_def" label="label" v-model="all_data.sales_person" :options="salespeoples"
             ></v-select>
           
    </div>
  </div>


    <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Loading Point</label>
            <input  v-model="all_data.loading_port"  style="font-size: small;" class="form-control" required>
         
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Driver Name</label>
            <input  v-model="all_data.driver_name"  style="font-size: small;" class="form-control" required>
    </div>
  </div>
  
 
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Loading Vehicle No </label>
            <input  v-model="all_data.loading_vehicle_no"  style="font-size: small;" class="form-control" required>
    </div>
  </div>

 
</div>

<div class="row">
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Accessories List</label>
           
           
            <v-select class="font-size_def"  :options="accessories" v-model="selectedAccessories" multiple 
                    :close-on-select="false" 
                    :clearable="true" ></v-select>
           
    </div>
  </div>
  
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Location</label>
            <v-select class="font-size_def" label="label"    v-model="all_data.dealer_id"  :options="mcustomers" ></v-select>
        
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Transfer Date</label>
            <input type="date"  v-model="all_data.transfer_date"  style="font-size: small;" class="form-control" required>
    </div>
  </div>


  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Remarks</label>
           <textarea v-model="all_data.remarks" class="form-control" rows="2"></textarea>
    </div>
  </div>

  
</div>

















<div class="card custom_bdr_rds">
        <div class="card-body custom_bdr_rds">
    <h6 class="purchitem mb-2"><b>Vehicle List</b></h6>
    <div class="table-responsive mb-1">
      <table style="font-size: small; " class="table  table-sm table-hover ">
        <thead class="background_color2">
          <tr>
                <th></th>
                <th  >   
                  <div class="form-group custom-form required">
                    <label class="custom-label2">Brand</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label2"> Model</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form ">
                    <label class="custom-label2">Engine / Chassis Available</label>
                  </div>
                </th>
                <th>
                  <div class="form-group custom-form required">
                    <label class="custom-label2"> Color</label>
                  </div>
                </th>
               
                
                
              
                <th></th>  
            </tr>
          </thead>
          <tbody>
            <tr>
                <td> </td>
              
              <td><input v-model="detail[0].brand_name"  style="font-size: small;" class="form-control text_right" disabled>
              
              </td>
             
              <td><input  v-model="detail[0].modelname" style="font-size: small;" class="form-control text_right" disabled></td>
              <td style="width: 50%;">
                <v-select  v-model="detail[0].engineno" label="label"  :options="engines" @input="loadbrand(0)"></v-select>
              </td>
              <td><input  v-model="detail[0].color" style="font-size: small;" class="form-control text_right"  disabled></td>
           
             
            
              <td class="custom-icon">  <b-icon @click="add" class="ms-2 mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon></td>
              
            </tr>
            <tr v-for="key in count" :key="key" >
                <td>
                    <b-icon @click="remove" class="ms-2 mt-2"  width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon>
                </td>
            
              <td><input  v-model="detail[key].brand_name" style="font-size: small;" class="form-control text_right" disabled>
              
              </td>
              <td><input  v-model="detail[key].modelname" style="font-size: small;" class="form-control text_right" disabled></td>
              <td> <v-select v-model="detail[key].engineno" label="label"  :options="engines" @input="loadbrand(key)"></v-select></td>
              <td><input  v-model="detail[key].color" style="font-size: small;" class="form-control text_right" @input="calculateqty(key)" disabled></td>
             


              <td class="custom-icon"> 
              
                 <b-icon @click="add" class="ms-3 mt-2"  width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon>
                 </td>
              
            </tr >
           
            
           
           
           

     
          
            
          </tbody>


        </table>
       
    </div>
    </div>
    </div>
    

    <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">Create</button>
    </div>
    </div>
    <br><br>


</form>




                </div>
                </div>
              </div> 
            </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    
    </template>
    <script src="/js/vue-select/vue-select.js"> </script>
    <script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/vue/1.0.13/vue.min.js"></script>

  
 



    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.loadSalespeople();
    this.loadCustomer();
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            count: 0,
        total:0,
        selectedOption: null, // Store the selected option
        subtotal:"0.00",
        gpmrg_total:"0.00",
        gpMrgPre_total:"0.00",
        final_total:"0.00",
        qty:0,
        selectedAccessories: [],
       
        mcustomers:[],
        mproducts:[],
        engines:[],
        contacts:[],
      salespeoples:[

      ],
      errors: {},
     
      squatation:{},
        customer:{},
        quotation:{
          'validity_period':{
            label: 'Select Validity Period', value: ''
          },
          'payment_method':{
            label: 'Cash', value: 'Cash'
          },
          'remarks':'',
          'special_discount':0.00,
        },
        sales:{},
        all_data:{
            loading_port:'210/1, Sri Dhamma Mawatha,Colombo 9',
        },
        Brands:[],
        detail:[
      {},  
      ],
      infoModal1: {
          id: 'info-modal1',
          title: '',
          content: [],
        },
      infoModal2: {
          id: 'info-modal2',
          title: '',
          content: [],
        },

      paymentmethods: [
            { label: 'Cash', value: 'Cash' },
            { label: '30 Days Credit', value: '30 Days Credit' },
            { label: '45 Days Credit', value: '45 Days Credit' },
            { label: '60 Days Credit', value: '60 Days Credit' },
            { label: 'Consignment', value: 'Consignment' },
            // Add more options as needed
        ],

        accessories: [
           { label: 'Tool Kit', value: 'Tool Kit'},
           { label: 'Wheel Brace', value: 'Wheel Brace'},
           { label: 'Operation Manual', value: 'Operation Manual'},
           { label: 'Jack & Lever', value: 'Jack & Lever'},
           { label: 'Spare Wheel', value: 'Spare Wheel'},
           { label: 'Seat Belt', value: 'Seat Belt'},
      ],
        validity_periodop: [
            { label: 'Select Validity Period', value: '' },
            { label: '7 Days', value: '7 Days' },
            { label: '14 Days', value: '14 Days' },
          
           
        ],
        variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark','mycoolor'],
        headerBgVariant: 'mycoolor',
        headerTextVariant: 'light',
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },
    

        methods : {

          async pendingProductqu(id,avlqty) {

            console.log(id.value);
  
      
          
         
       try {
         const { data} = await  axios.get('/squatation/pendingproductqu?id='+id.value,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          
            // this.loadSquatation();
           this.qty = avlqty-data.qty;
         
            this.infoModal2.content = data.results;
            this.$root.$emit('bv::show::modal', this.infoModal2.id);
        
         
       } catch (error) {
         console.log(error.response);
       }
     },





          async pendingQuotation() {
       console.log(this.squatation.idcustomer.value);
      
          
         
       try {
         const { data} = await  axios.get('/squatation/pendingquotation?id='+this.squatation.idcustomer.value,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          
            // this.loadSquatation();
           
            this.infoModal1.content = data.results;
            this.$root.$emit('bv::show::modal', this.infoModal1.id);
        
         
       } catch (error) {
         console.log(error.response);
       }
     },

          async loadSalespeople() {
       
     
      try {
        const { data} = await  axios.get('/msalespeople/salespeopleload',{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.salespeoples = data.item_list;
        
      } catch (error) {
        console.log(error.response);
      }
    },

    
    async loadCustomer() {
       
     
       try {
         const { data} = await  axios.get('/mcustomer/customerload',{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.mcustomers = data.customers;
          this.contacts = data.contacts;
          this.mbrands = data.mbrands;
          this.mproducts = data.mproducts;
         
       } catch (error) {
         console.log(error.response);
       }


       try {
         const { data} = await  axios.post('/idealerassignvehicle/loadengine',{idcustomer:this.squatation.idcustomer},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.engines = data.engines;
          
         
       } catch (error) {
         console.log(error.response);
       }



     },

    
       
     
       
   

     async loadBrand() {
       
     
       try {
         const { data} = await  axios.post('/mcustomer/loadproduct',{id_brand:this.quotation.id_brand},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.mproducts = data.mproducts;
          // this.sales = data.salespeoples;
          
         
       } catch (error) {
         console.log(error.response);
       }
     },

     async loadbrand(id) {
       
     
       try {
         const { data} = await  axios.post('/idealerassignvehicle/loadbrand',{engineno:this.detail[id].engineno},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.$set(this.detail[id], 'brand_name', data.brand_name);
          this.$set(this.detail[id], 'modelname', data.modelname);
          this.$set(this.detail[id], 'color', data.color);
          // this.sales = data.salespeoples;
          
         
       } catch (error) {
         console.log(error.response);
       }
     },

    

    async SaveQuotation() {
     
      

     
        try {
         const { data} = await  axios.post('/idealerassignvehicle/create',{userid:this.userid,all_data:this.all_data,detail:this.detail,selectedAccessories:this.selectedAccessories},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
        if(data.status==200){
          this.$router.push('/idealerassignvehicle/index');
        }
          
           
         
       } catch (error) {
         console.log(error.response);
       }
    
       
      
 
      
     },
       

        add: function(){
            this.count++;
            this.detail.push({
             
            },)
           
        },

  remove: function () {
            this.count--;
            this.detail.splice({
              
            },1)
            
        },

    },
    
    }
    
    </script>

    <style scoped>
    .button-link {
  display: inline-block;
  padding: 5px 10px;
  font-size: small;
  text-decoration: none;
  color: #3899ea;
 
 
  
  cursor: pointer;
}

.button-link:hover {
  color: black;
  text-decoration: underline;
}
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */
    </style>
    